<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card class="mb-1">
          <v-card-title>
            <span class="homeTop">Seller Offers</span>
            <v-spacer></v-spacer>
            <v-flex xs6 text-right>
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="800px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="red" outlined v-bind="attrs" v-on="on">
                    Add Offer
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Add Offer</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-flex xs12 md12 px-md-3 px-lg-3 px-xl-3>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-select
                              v-model="seller"
                              :items="sellerArray"
                              item-text="sellerid.shopName"
                              item-value="_id"
                              item-color="#8d8d8d"
                              color="#8d8d8d"
                              outlined
                              dense
                              label="Select seller"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              v-model="city"
                              :items="cityArray"
                              item-text="name"
                              item-value="value"
                              item-color="#8d8d8d"
                              color="#8d8d8d"
                              outlined
                              multiple
                              dense
                              label="Select City"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 pt-5>
                            <v-text-field
                              class="homeText"
                              outlined
                              dense
                              v-model="name"
                              label=" Name of the Offer"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 py-5>
                            <span class="homeText">
                              Description of the Offer</span
                            >
                            <div id="app">
                              <vue-editor v-model="description"></vue-editor>
                            </div>
                          </v-flex>
                          <v-flex md12 xs12 py-5>
                            <ImageCom
                              @stepper="winStepper"
                              :heading="'Upload Image'"
                              :componentType="'topimage'"
                            />
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="startingDate"
                                  label="From Date"
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="startingDate"
                                no-title
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm6 md3 pl-2>
                            <v-menu
                              ref="menu2"
                              v-model="menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="endingDate"
                                  label="To Date"
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="endingDate"
                                no-title
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm6 md3 pl-2>
                            <v-menu
                              ref="menu3"
                              v-model="menu3"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="startingTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="startingTime"
                                  label="Starting Time"
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu3"
                                v-model="startingTime"
                                full-width
                                @click:minute="$refs.menu3.save(startingTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm6 md3 pl-2>
                            <v-menu
                              ref="menu4"
                              v-model="menu4"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="endingTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="endingTime"
                                  label="Ending Time"
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu4"
                                v-model="endingTime"
                                full-width
                                @click:minute="$refs.menu4.save(endingTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-layout justify-start wrap pl-2 pb-5>
                            <v-flex xs12>
                              <!-- <img
                                v-if="imagePreview"
                                :src="imagePreview"
                                v-show="showPreview"
                                width="390px"
                                height="150px"
                                class="align-center"
                                contain
                              /> -->
                              <!-- <img
                      v-else
                      :src="baseURL + '/file/get/' + seller.coverPhoto"
                      width="390px"
                      height="150px"
                      class="align-center"
                      contain
                    /> -->
                            </v-flex>
                            <!-- <v-flex xs12 sm7 md6 lg6>
                              <v-btn
                                width="180px"
                                block
                                tile
                                depressed
                                :ripple="false"
                                class="text-capitalize"
                                color="#F6F5FF"
                                @click="$refs.showImage.click()"
                              >
                                <v-layout justify-center wrap>
                                  <v-flex xs2 sm2 md2 text-left>
                                    <v-icon style="color: #000000"
                                      >mdi-upload</v-icon
                                    >
                                  </v-flex>
                                  <v-flex xs10 sm8 md10>
                                    <span class="image">Upload Image</span>
                                  </v-flex>
                                </v-layout>
                              </v-btn>
                              <input
                                v-show="false"
                                accept="image/*"
                                id="file"
                                ref="showImage"
                                multiple="multiple"
                                type="file"
                                @change="showImage"
                              />
                            </v-flex> -->
                          </v-layout>
                        </v-layout>
                      </v-flex>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                      Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="add()">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-card-title>
        </v-card>
        <v-layout wrap justify-start v-if="list.length > 0">
          <v-flex v-for="(item, i) in list" :key="i" md3 pa-4>
            <v-card style="line-height: 16px">
              <v-img
                v-if="item.photo"
                style="width: 100%; object-fit: contain; cursor: pointer"
                :src="baseURL + '/file/get/' + item.photo"
                height="300px"
                cover>
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center">
                    <v-progress-circular
                      indeterminate
                      color="#FF2323"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-img
                v-else
                height="300px"
                src="./../../assets/images/noimage.png"
              ></v-img>
              <v-layout wrap justify-center px-2 py-4>
                <v-flex xs6 sm6 md6 align-self-end text-right pa-4>
                  <v-btn
                    @click="changeStatus(item)"
                    :color="item.status == 'inactive' ? 'red' : 'blue'"
                    small
                    block
                    class="px-3"
                    :ripple="false"
                    depressed
                  >
                    <span style="font-size: 12px; color: #ffffff">{{
                      item.status
                    }}</span>
                  </v-btn>
                </v-flex>
                <v-flex text-center xs12>
                  <span class="homeName"> {{ item.name }} </span><br /><br />
                  <span
                    class="showLine"
                    style="font-size: 13px; color: #000000"
                    v-html="item.description"
                  >
                  </span>
                </v-flex>
                <v-flex pt-5 xl6 lg6 md6 pb-2 sm6 xs6 px-5 justify-center>
                  <v-dialog v-model="item.delete" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="mr-2"
                        outlined
                        block
                        v-on="on"
                        v-bind="attrs"
                        color="red"
                      >
                        Delete
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title
                        >Are you sure you want to delete this
                        Offer?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="item.delete = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItem(item)"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
                <v-flex pt-5 xl6 lg6 md6 pb-2 sm6 xs6 px-5 justify-center>
                  <v-btn
                    small
                    class="mr-2"
                    outlined
                    block
                    color="green"
                    @click="editSlider(item)"
                  >
                    Edit
                  </v-btn>
                </v-flex>
                <br />
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else justify-center wrap pt-5>
          <v-flex xs12 text-center>
            <span class="homeText">No Data Found.....</span>
          </v-flex>
        </v-layout>
        <v-dialog v-model="editdialog" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">Edit Offer</span>
            </v-card-title>
            <v-card-text>
              <v-layout justify-center wrap>
                <v-flex xs12>
                  <v-text-field
                    class="homeText"
                    outlined
                    dense
                    v-model="editingitem.name"
                    label="Name of the Offer"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="editingitem.cities"
                    :items="cityArray"
                    item-text="name"
                    item-value="value"
                    item-color="#8d8d8d"
                    color="#8d8d8d"
                    outlined
                    multiple
                    dense
                    label="Select City"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <span class="homeText">Description of the Offer</span>
                  <div id="app">
                    <vue-editor v-model="editingitem.description"></vue-editor>
                  </div>
                </v-flex>
                <v-flex md12 xs12 py-5>
                  <ImageCom
                    @stepper="winStepper"
                    :singleImage="editingitem.photo"
                    :heading="'Upload Image'"
                    :componentType="'topimage'"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.startingDate"
                        label="From Date"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingitem.startingDate"
                      no-title
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md3 pl-2>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.endingDate"
                        label="To Date"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingitem.endingDate"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md3 pl-2>
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="editingitem.startingTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.startingTime"
                        label="Starting Time"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu3"
                      v-model="editingitem.startingTime"
                      full-width
                      @click:minute="$refs.menu3.save(editingitem.startingTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md3 pl-2>
                  <v-menu
                    ref="menu4"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="editingitem.endingTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.endingTime"
                        label="Ending Time"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu4"
                      v-model="editingitem.endingTime"
                      full-width
                      @click:minute="$refs.menu4.save(editingitem.endingTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="editdialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="edit(editingitem._id)">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <div class="text-center pb-5" v-if="pages > 1">
      <v-pagination
        :length="pages"
        :total-visible="7"
        v-model="currentPage"
        color="red"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ImageCom from "@/components/commonComponents/singleImage";
import { VueEditor } from "vue2-editor";
import moment from "moment";
export default {
  components: {
    ImageCom,
    VueEditor,
  },
  data() {
    return {
      name: null,
      description: null,
      startingDate: new Date(),
      endingDate: new Date(),
      startingTime: "",
      endingTime: "",
      list: [],
      seller: "",
      sellerArray: [],
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      editingitem: [],
      dialog: false,
      editdialog: false,
      ServerError: false,
      showSnackBar: false,
      appLoading: false,
      timeout: 5000,
      msg: null,
      city: null,
      cityArray: [],
      formData: new FormData(),
      selectedFiles: [],
      image: null,
      imagePreview: "",
      showPreview: false,
      file: null,
      formDataCover: new FormData(),
      page: 1,
      currentPage: 1,
      pages: 0,
      limit: 12,
      totalData: 0,
      topimageFile: null,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
    if (this.startingDate) {
      this.startingDate.setDate(this.startingDate.getDate());
      this.startingDate = this.startingDate.toISOString().substr(0, 10);
    }
    if (this.endingDate) {
      this.endingDate.setDate(this.endingDate.getDate());
      this.endingDate = this.endingDate.toISOString().substr(0, 10);
    }
    this.getSeller();
    this.getPlace();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "topimage") {
        this.topimageFile = window_data.selectedFiles;
      }
    },
    DateFormatted(params) {
      return params ? moment(params).format("DD-MMMM-Y <br> hh:mm A") : "";
    },
    validateInput() {
      if (!this.name) {
        this.msg = "Please Provide Name of the offer";
        this.showSnackBar = true;
        return;
      } else if (!this.description) {
        this.msg = "Please Provide Description of the offer";
        this.showSnackBar = true;
        return;
      } else {
        this.add();
      }
    },
    getList() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/admin/seller/offer/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          limit: this.limit,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.list = response.data.data;
          this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          (this.appLoading = false), (this.ServerError = true);
          console.log(err);
        });
    },
    getPlace() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/sellers/city/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.cityArray = response.data.data;
          // var temp = [
          //   {
          //     name: null,
          //     value: null,
          //   },
          // ];
          // temp = response.data.data;
          // for (var i = 0; i < temp.length; i++) {
          //   temp[i].name = temp[i].name;
          //   temp[i].value = temp[i]._id;
          // }
          // this.placeArray = temp;
          // this.placeArray.unshift({ name: "All", value: null });
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getSeller() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sellers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.sellerArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    changeStatus(id) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/offer/status/change/" + id._id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.getList();
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    showImage(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showSnackBar = true;
        return;
      }
      this.showPreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    add() {
      this.formDataCover.append("userid", this.seller);
      this.formDataCover.append("cities", this.city);
      this.formDataCover.append("name", this.name);
      this.formDataCover.append("description", this.description);
      this.formDataCover.append("startingTime", this.startingTime);
      this.formDataCover.append("startingDate", this.startingDate);
      this.formDataCover.append("endingTime", this.endingTime);
      this.formDataCover.append("endingDate", this.endingDate);
      this.formDataCover.append("photo", this.topimageFile);
      axios({
        method: "post",
        url: "/admin/seller/offer/add",
        data: this.formDataCover,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.dialog = false;
            this.msg = " Added Successully";
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      this.formDataCover.append("name", this.editingitem.name);
      this.formDataCover.append("cities", this.editingitem.cities);
      this.formDataCover.append("description", this.editingitem.description);
      this.formDataCover.append("startingDate", this.editingitem.startingDate);
      this.formDataCover.append("startingTime", this.editingitem.startingTime);
      this.formDataCover.append("endingDate", this.editingitem.endingDate);
      this.formDataCover.append("endingTime", this.editingitem.endingTime);
      this.formDataCover.append("photo", this.topimageFile);
      this.formDataCover.append("id", this.editingitem._id);
      axios({
        method: "POST",
        url: "/admin/seller/offer/edit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.formDataCover,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.getList();
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      this.editingitem.startingDate = this.editingitem.starting.slice(0, 10);
      this.editingitem.endingDate = this.editingitem.ending.slice(0, 10);
      this.editingitem.startingTime = this.editingitem.starting.slice(11, 16);
      this.editingitem.endingTime = this.editingitem.ending.slice(11, 16);
      this.editdialog = true;
    },
    deleteItem(r) {
      axios({
        url: "/admin/seller/offer/delete/" + r._id,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showSnackBar = true;
            this.getList();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>